<template>
  <div class="welcome">
    <div class="welcome-bg"></div>
    <div class="welcome-content">
      <h2>
        {{ $t('com_hi') }},<span v-if="userInfo">{{ userInfo.user.userName }},</span>
        <i>{{ $t('com_welcome') }}</i>
      </h2>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {};
  },
  created() {
    this.$store.commit('setPageLoading', false);
  },
  computed: {
    ...mapGetters(['userInfo', 'authList']),
  },
};
</script>

<style lang="less" scoped>
.welcome {
  height: 100%;
  position: relative;
  .welcome-bg {
    background: url('~@/assets/img/bg.jpeg');
    background-size: cover;
    opacity: 0.5;
    position: absolute;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
  }
  .welcome-content {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50%;
    font-size: 18px;
    position: relative;
    z-index: 2;

    h2 {
      font-weight: normal;
      color: #666;
      i {
        font-style: normal;
      }
      span {
        color: #006f6d;
        padding: 0 10px;
      }
    }
  }
}
</style>
